import React from "react";
import "./assets/css/bootstrap.min.css";
import "./assets/scss/now-ui-kit.scss";
import "./assets/demo/demo.css";
import ProfilePage from "./Page";

function App() {
  return <ProfilePage />;
}

export default App;
